(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["formula-featured-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get("formula-featured-products")) {
    customElements.define(
      "formula-featured-products",
      class FormulaFeaturedProducts extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;

          this.initialized = true;
          this.tabs = Array.from(this.querySelectorAll("[data-formula-collection-tab]"));
          this.panels = Array.from(this.querySelectorAll("[data-formula-collection-panel]"));
          this.collectionLink = this.querySelector("[data-formula-collection-link]");

          this.handleClick = this.handleClick.bind(this);
          this.handleKeydown = this.handleKeydown.bind(this);
          this.handleBlockSelect = this.handleBlockSelect.bind(this);

          this.addEventListener("click", this.handleClick);
          this.addEventListener("keydown", this.handleKeydown);
          this.addEventListener("shopify:block:select", this.handleBlockSelect);
        }

        disconnectedCallback() {
          this.removeEventListener("click", this.handleClick);
          this.removeEventListener("keydown", this.handleKeydown);
          this.removeEventListener("shopify:block:select", this.handleBlockSelect);
          this.initialized = false;
        }

        handleClick(event) {
          const tab = event.target.closest?.("[data-formula-collection-tab]");
          const index = this.tabs.indexOf(tab);

          if (index >= 0) {
            this.selectTab(index);
          }
        }

        handleBlockSelect(event) {
          const panel = event.target.closest?.("[data-formula-collection-panel]");
          const index = this.panels.indexOf(panel);

          if (index >= 0) {
            this.selectTab(index);
          }
        }

        selectTab(index, focus = false) {
          if (!this.tabs[index] || !this.panels[index]) return;

          this.tabs.forEach((tab, tabIndex) => {
            const isActive = tabIndex === index;
            tab.setAttribute("aria-selected", isActive.toString());
            tab.tabIndex = isActive ? 0 : -1;
          });

          this.panels.forEach((panel, panelIndex) => {
            panel.hidden = panelIndex !== index;
          });

          if (this.collectionLink) {
            this.collectionLink.href = this.tabs[index].dataset.collectionUrl;
          }

          if (focus) {
            this.tabs[index].focus();
          }
        }

        handleKeydown(event) {
          const tab = event.target.closest?.("[data-formula-collection-tab]");
          const index = this.tabs.indexOf(tab);

          if (index < 0) return;

          const lastIndex = this.tabs.length - 1;
          let nextIndex = index;

          if (event.key === "ArrowRight") nextIndex = index === lastIndex ? 0 : index + 1;
          if (event.key === "ArrowLeft") nextIndex = index === 0 ? lastIndex : index - 1;
          if (event.key === "Home") nextIndex = 0;
          if (event.key === "End") nextIndex = lastIndex;
          if (nextIndex === index) return;

          event.preventDefault();
          this.selectTab(nextIndex, true);
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();
})();
